<mat-drawer-container autosize>
  <mat-card class="custom-mat-card">
    <mat-card-content class="custom-mat-card-content">
      <div class="custom-container">
        <div class="header-title header-height no-backround">
          <div class="custom-header-row header-row-height">
            <span id="customers_add_edit_header_text" class="page-header-text">
              {{ pageType() | titlecase }} Customer
            </span>
            <span class="spacer"></span>
            <button
              mat-button
              id="managers_add_edit_cancel_1"
              class="add-edit-button white-button margin-right-15"
              routerLink="/customers">
              Cancel
            </button>
            <button
              mat-button
              id="managers_add_edit_save"
              class="add-edit-button save-button"
              [ngClass]="{ 'invalid-button': !isFormValid() }"
              (click)="onSubmit()">
              Save
            </button>
          </div>
        </div>
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          class="custom-mat-tabs"
          (selectedIndexChange)="selectedTabIndex.set($event)">
          <mat-tab id="details_tab" label="Customer Details">
            <ng-template matTabContent
              ><app-customer-form
                #customerForm
                (formValid)="isFormValid.set($event)"
                (isCreateForm)="isCreateForm.set($event)"
                (customerKeyChange)="customerKey.set($event)" />
            </ng-template>
          </mat-tab>

          <mat-tab id="idp_tab" label="Identity Provider Settings" [disabled]="isCreateForm()">
            <ng-template matTabContent
              ><app-customer-idp-form
                #idpForm
                [customerKey]="customerKey()"
                (formValid)="isFormValid.set($event)"
            /></ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
